import React from "react";
import PageHeader from "../../components/common/PageHeader";
import LatestServiceOffer from "../../components/common/LatestServiceOffer";
import BlogHeroSection from "../../components/Blogs/BlogHeroSection";

const Blogs = () => {
  return (
    <div>
      <PageHeader title="Blogs" />
      <BlogHeroSection />
      <LatestServiceOffer />
    </div>
  );
};

export default Blogs;
